import React, { useState, useEffect } from "react";
import { EventType } from "pages/statuses/EventType";
import { ConfirmParts } from "pages/booking/dialogParts/ConfirmParts";
import { BookingApi } from "api/BookingApi";
import { LiquidWasteBooking } from "api/entities/LiquidWasteBooking";
import * as CommonConstants from "utilities/CommonConstants";
import { BookingUtil } from "pages/booking/BookingUtil";
import { Loading } from "pages/parts/Loading";
interface Props {
    match: any;
}

export const Confirm: React.FC<Props> = (props) => {
    // ローディング
    const [isLoading, setLoading] = useState<boolean>(false);
    const [targetBooking, setTargetBooking] = useState<EventType>({
        id: ``,
        start: new Date(),
        end: new Date(),
        classNames: [],
        groupId: ``,
        bookingTypeId: 0,
        status: 0,
        subscriberFaculty: ``,
        subscriberDepartment: ``,
        subscriberName: ``,
        subscriberLaboratoryId: ``,
        subscriberLaboratoryName: ``,
        subscriberMailAddress: ``,
        subscriberTel: ``,
        subscriberMemo: ``,
        numberOfChemicals: 0,
        solidWasteBookingDetails: [],
        liquidWasteBookingDetails: [],
        depositBookingDetails: [],
    });

    useEffect(() => {
        const execute = async () => {
            // 予約情報を取得
            const result = await BookingApi.getBookingForConfirmByEncryptedId(props.match.params.id);

            if (result?.status === 200) {
                const bookingEntities: LiquidWasteBooking = result.data;
                const bookings = convertBookings(bookingEntities);

                const booking: EventType = {
                    id: bookings.id.toString(),
                    start: bookings.start,
                    end: bookings.end,
                    classNames: bookings.classNames,
                    groupId: CommonConstants.GROUP_ID_BOOKING,
                    bookingTypeId: bookings.bookingTypeId,
                    status: bookings.status,
                    subscriberFaculty: bookings.subscriberFaculty,
                    subscriberDepartment: bookings.subscriberDepartment,
                    subscriberName: bookings.subscriberName,
                    subscriberLaboratoryId: bookings.subscriberLaboratoryId,
                    subscriberLaboratoryName: bookings.subscriberLaboratoryName,
                    subscriberMailAddress: bookings.subscriberMailAddress,
                    subscriberTel: bookings.subscriberTel,
                    subscriberMemo: bookings.subscriberMemo,
                    numberOfChemicals: bookings.numberOfChemicals,
                    solidWasteBookingDetails: bookings.solidWasteBookingDetails,
                    liquidWasteBookingDetails: bookings.liquidWasteBookingDetails,
                    depositBookingDetails: bookings.depositBookingDetails,
                };
                setTargetBooking(booking);
            }
        };
        execute();
    }, [props.match.params.id]);

    /**
     * DBから取得した予約情報を、イベント情報として持ち回せるよう詰め替える
     * @param bookingEntities DBから取得した予約情報
     * @return 予約イベント
     */
    const convertBookings = (bookingEntities: LiquidWasteBooking): EventType => {
        const bookings: EventType = {
            id: bookingEntities.id.toString(),
            start: new Date(bookingEntities.bookingStartTime),
            end: new Date(bookingEntities.bookingEndTime),
            classNames: [`${BookingUtil.getClassNameByBookingType(bookingEntities.bookingTypeId)}`],
            groupId: CommonConstants.GROUP_ID_BOOKING,
            bookingTypeId: bookingEntities.bookingTypeId,
            status: bookingEntities.status,
            subscriberFaculty: bookingEntities.subscriberFaculty,
            subscriberDepartment: bookingEntities.subscriberDepartment,
            subscriberName: bookingEntities.subscriberName,
            subscriberLaboratoryId: bookingEntities.subscriberLaboratoryId,
            subscriberLaboratoryName: bookingEntities.subscriberLaboratoryName,
            subscriberMailAddress: bookingEntities.subscriberMailAddress,
            subscriberTel: bookingEntities.subscriberTel !== null ? bookingEntities.subscriberTel : undefined,
            subscriberMemo: bookingEntities.subscriberMemo !== null ? bookingEntities.subscriberMemo : undefined,
            numberOfChemicals: bookingEntities.numberOfChemicals !== null ? bookingEntities.numberOfChemicals : undefined,
            solidWasteBookingDetails: bookingEntities.solidWasteBookingDetails,
            liquidWasteBookingDetails: bookingEntities.liquidWasteBookingDetails,
            depositBookingDetails: bookingEntities.depositBookingDetails,
        };
        return bookings;
    };

    return (
        <div>
            {targetBooking.id !== `` && <ConfirmParts booking={targetBooking} setLoading={setLoading} />}
            <Loading isLoading={isLoading} />
        </div>
    );
};
